import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";
import Types from "constants/Types";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ListItemText from "@material-ui/core/ListItemText";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import API from "@beardeddevops/react.api";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import {Checkbox} from "@mui/material";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Reservations',
		url: '/reservations',
		icon: 'calendar-check-o',
	},
];

export default class Reservation extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.question = null;
		this.state.question_binary_id = null;

		this.state.anchorGen = null;
		this.state.anchorEForm = null;
		this.state.use_default_questions = true;
		this.state.transaction_purposes = '';
	}

	handleOpen = (el) =>  async event => {
		this.setState({
			[el]: event.currentTarget,
		});

	};

	handleClose = (anchor) => {
		this.setState({
			[anchor]: null,
		});
	};

	updateData = (id, binary_id) => {
		this.setState({
			question: id,
			question_binary_id: binary_id,
		})
	};

	printPdf = (form) => async () => {
		this.handleClose();
		let model = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);

		model.object.form = form;
		model.parent = this.props.match.params.id;

		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return;
		}

		this.setState({tab: 'forms'})

		this.refreshPage();
	};



	setFlagMessage = (event) => {
		this.setState({[event.target.name]: event.target.value});
	};

	randomHash = async (length) => {
		let result = '';
		const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		const charactersLength = characters.length;
		let counter = 0;
		while (counter < length) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
			counter += 1;
		}
		return result;
	}




	launchEForm = async (form) => {
		let eFormModel = new API.BuildClass(Types.E_Form_Logs._name, 'PUT_FOR_RESERVATION');
		let pending_hash = await this.randomHash(16);
		this.setState({
			atf_hash: pending_hash,
			reservation_name: this.state.name,
			form_number: form,
		})
		eFormModel.object.atf_hash = pending_hash;
		eFormModel.object.reservation_name = this.state.name;
		eFormModel.object.form_number = form;
		localStorage.setItem('e_form_hash', pending_hash);
		await eFormModel.submit(null, 'PUT_FOR_RESERVATION', true);

		if(form == 1 || form == 4) {
			this.setState({showEFormModal: true})
		}
		if (form == 2 || form == 3) {
			this.setState({loading: true})
			await new Promise(r => setTimeout(r, 3000));
			this.setState({loading: false})
			this.props.history.push('/eForms_products');
			window.open('https://eforms.atf.gov/login', '_blank');
			this.setState({ showEFormModal: false });
			await new Promise(r => setTimeout(r, 3000));
			this.props.history.push('/reservations/' + this.props.id)

		}

	}

	render() {
		let {anchorGen, anchorEForm} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/reservations/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);
0
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button
						size="sm"
						color="primary"
						aria-owns={anchorEForm ? 'anchorEForm' : null}
						aria-haspopup="true"
						onClick={this.handleOpen('anchorEForm')}
					>
						<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate eForm
					</Button>
					<Menu
						id="anchorGen"
						anchorEl={anchorEForm}
						open={Boolean(anchorEForm)}
						onClose={() => this.handleClose('anchorEForm')}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'left', vertical: 'top'}}
					>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="General Forms"/>
						</MenuItem>
						<MenuItem onClick={() => this.launchEForm('1')}>
							<ListItemText id={'form_1'} inset primary="ATF Form 1 (5320.1) - Application to Make and Register a Firearm"/>
						</MenuItem>
						<MenuItem onClick={() => this.launchEForm('2')}>
							<ListItemText id={'form_2'} inset primary="ATF Form 2 (5320.2) - Notice of Firearms Manufactured or Imported"/>
						</MenuItem>
						<MenuItem onClick={() => this.launchEForm('3')}>
							<ListItemText id={'form_3'} inset primary="ATF Form 3 (5320.3) - Application for Tax Exempt Transfer of Firearm and Registration to Special Occupational Taxpayer (NFA)"/>
						</MenuItem>
						<MenuItem onClick={() => this.launchEForm('4')}>
							<ListItemText id={'form_4'} inset primary="ATF Form 4 (5320.4) - Application for Tax Paid Transfer and Registration of Firearm"/>
						</MenuItem>
					</Menu>



					<Button
						size="sm"
						color="primary"
						aria-owns={anchorGen ? 'anchorGen' : null}
						aria-haspopup="true"
						onClick={this.handleOpen('anchorGen')}
					>
						<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate Paper Form
					</Button>
					<Menu
						id="anchorGen"
						anchorEl={anchorGen}
						open={Boolean(anchorGen)}
						onClose={() => this.handleClose('anchorGen')}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'left', vertical: 'top'}}
					>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="General Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(9)}>
							<ListItemText inset primary="Form 2 - Notice of Firearms Manufactured or Imported"/>
						</MenuItem>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="Dealer Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(6)}>
							<ListItemText inset primary="Form 3 - Application for Tax-Exempt Transfer of Firearm"/>
						</MenuItem>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="Customer & Legal Entity / Trust Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(15)}>
							<ListItemText inset primary="Form 4 - Application for Tax Paid Transfer and Registration of Firearms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(11)}>
							<ListItemText inset primary="Form 5 - Application for Tax Exempt Transfer and Registration of Firearm"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(10)}>
							<ListItemText inset primary="Form 23 - Responsible Person Questionnaire"/>
						</MenuItem>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="Except Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(12)}>
							<ListItemText inset primary="Form 9 - Application and Permit for Permanent Exportation of Firearms"/>
						</MenuItem>
					</Menu>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Reservation" value={'details'}/>
					<Tab label="Eligibility" value={'eligibility'}/>
					<Tab label="Forms" value={'forms'}/>
					<Tab label="Change Log" value={'logs'}/>
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Reservation
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateData={this.updateData}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						updateName={this.updateName}
					/>
				</div>
				{this.state.tab === 'eligibility' &&
				<Objects.ReservationEligibility
					id={this.state.question}
					binary_id={this.state.question_binary_id}
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
				/>}
				{this.state.tab === 'forms' &&
				<Collections.Forms
					parent={this.props.match.params.id}
					forForm={Types.Transactions_Collections_Forms._name}
					url={'/transactions/[PARENT]/collections_forms'}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'logs' &&
				<Collections.LogsReservations
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}

				<Modal
					isOpen={this.state.showEFormModal}
					toggle={() => this.setState({ showEFormModal: false })}
					centered // Optional: Centers the modal vertically/horizontally
					backdrop="static" // Matches your closeOnClickOutside: false (prevents backdrop close)
				>
					{this.state.form_number === '1' ? <ModalHeader toggle={() => this.setState({ showEFormModal: false })}>
						State Why You Intend To Make Firearm
					</ModalHeader> : <ModalHeader toggle={() => this.setState({ showEFormModal: false })}>
						Transferee Necessity Statement (State a reasonable necessity to possess the machinegun, short-barreled rifle, short-barreled shotgun, or destructive device)
					</ModalHeader>}
					<ModalBody>
						<TextField
							fullWidth
							margin="dense"
							variant="outlined"
							name="transaction_purposes"
							placeholder="Details / Explanation"
							value={this.state.transaction_purposes}
							onChange={this.setFlagMessage}
						/>
						<div className="row" style={{ marginTop: '15px' }}>
							<div className="col-9">
								<span className="input-label">Use Standard eForms Questions</span>
							</div>
							<div className="form-group">
								<Checkbox
									checked={this.state.use_default_questions}
									onChange={(e) => this.setState({use_default_questions: e.currentTarget.checked})}
									style={{
										maxWidth: 250,
										marginBottom: 0,
										marginTop: 0
									}}
								/>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<button
							onClick={() => this.setState({ showEFormModal: false })}
							style={{ marginRight: '0', marginLeft: '10px' }}
							className="btn btn-default"
						>
							Cancel
						</button>
						<button
							onClick={async (rand=this) => {
								localStorage.setItem('use_default_questions', this.state.use_default_questions);
								localStorage.setItem('transaction_purposes', this.state.transaction_purposes);
								this.props.history.push('/eForms_products');
								window.open('https://eforms.atf.gov/login', '_blank');
								this.setState({ showEFormModal: false });
								await new Promise(r => setTimeout(r, 3000));
								this.props.history.push('/reservations/' + this.props.id)


							}}
							style={{ marginRight: '0', marginLeft: '10px' }}
							className="btn btn-success"
						>
							Save
						</button>
					</ModalFooter>
				</Modal>
				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>

			</div >
		);
	}
};
